import { render, staticRenderFns } from "./CheckboxQuestion.vue?vue&type=template&id=a67abbde&scoped=true&"
import script from "./CheckboxQuestion.vue?vue&type=script&lang=js&"
export * from "./CheckboxQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67abbde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
